import { Component } from '@angular/core';
import { AppService } from './services/app-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  getPageDate = false;
  constructor(private appService:AppService) {
    this.appService.getPagesList().subscribe((res:any)=>{
      this.appService.setPages(res);
      this.getPageDate = true;
    })
  }
}
